import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';

export const FJSliceModals = createSlice({
    name: 'modals',
    initialState: {
        detailsPreviewModalData: {
            data: {},
            display: false,
        },
        warningModalData: {
            title: '',
            content: '',
            display: false,
            footerDates: [],
        },
        previewModalData: {
            data: {},
            display: false,
        },
        imagePreviewModalData: {
            display: false,
            imageList: [],
            currentIndex: 0,
            onIndexChange: null,
        },
        imageCropModalData: {
            imageUrl: '',
            display: false,
            onConfirm: null,
            onCancel: null,
            inputType: 'file', // file | url
            minHeight: 0,
            minWidth: 0,
            maxHeight: Infinity,
            maxWidth: Infinity,
        },
        upgradeModalData: {
            display: false,
        },

        uploadImageAsPromptModalData: {
            display: false,
        },

        loadingModalData: {
            display: false,
            message: '',
        },
        mobilePreviewData: {
            data: {},
            display: false,
        },

        upgradeTipsModalData: {
            data: {},
            display: false,
        },

        mobileSimplePreviewData: {
            data: {},
            display: false,
        },
        addAsEditPageModalBtuStatus: FJConstant.SUCCESS,
        globalLoadingDisplay: false,
        mobileFooterModalData: {
            title: '',
            children: null,
            hasMask: '',
            display: false,
        },
        isShowRecordDisplay: false,
        addMediaLibraryInfo: {
            visible: false,
            list: [],
        },
        autoSelectionNoticeDisplay: false,

        videoTrimModelData: {
            display: false,
            data: {
                // src: 'https://www.smartvideomaker.com/ai/export/video-background-remove/150472aa6346b9816ffc74cd6e3cbf7b.webm',
                // width: 1920,
                // height: 1080,
                // duration: 10,
            },
        },
        serverBusyModalData: {
            display: false,
        },
        animateImageModalDisplay: false,
        timeDiscountPanelData: {
            visible: false,
        },
        timeDiscountSelectedIndex: 1,

        progressModalData: { display: false, cancelCallback: null },
        progress: 0,
        mediaPreviewData: {
            //预览（新）
            id: '',
            url: '',
            viewSize: {},
            duration: 0,
            type: '',
            active: false,
            previewItemId: null, // 点击预览的 view 的 id，用于 stock 里 recently used 和列表里面有相同素材时的区分
        },
        doNotShowAgainData: {
            display: false,
            /**
             * 决定渲染内容
             */
            type: null,
            /**
             * 添加到 local storage 中的key， 当key存在不再弹出， 不存在则弹出
             */
            id: '',
        },
        cloudTranscodingModalData: {
            display: false,
            // 弹窗回调
            onClose: null,
            onConfirm: null,
            onCancel: null,
            onRestart: null,
            onReupload: null,
            // 输入框配置
            inputOptions: {},
        },

        reportModalData: {
            display: false,
        },
    },
    reducers: {
        setSliceReportModalData: (state, action) => {
            state.reportModalData = action.payload;
        },
        setProgressAction: (state, action) => {
            state.progress = action.payload;
        },
        setProgressModalData: (state, action) => {
            state.progressModalData = action.payload;
        },
        setSliceWarningModalData: (state, action) => {
            state.warningModalData = action.payload;
        },
        setSliceDetailsPreviewModalData: (state, action) => {
            state.detailsPreviewModalData = action.payload;
        },
        setSlicePreviewModalData: (state, action) => {
            state.previewModalData = action.payload;
        },
        setSliceImagePreviewModalData: (state, action) => {
            state.imagePreviewModalData = action.payload;
        },
        setSliceImageCropModalData: (state, action) => {
            state.imageCropModalData = action.payload;
        },
        setSliceUpgradeModalData: (state, action) => {
            state.upgradeModalData = action.payload;
        },
        setSliceUploadImageAsPromptModalData: (state, action) => {
            state.uploadImageAsPromptModalData = action.payload;
        },
        setSliceAddAsEditPageModalBtuStatus: (state, action) => {
            state.addAsEditPageModalBtuStatus = action.payload;
        },
        setSliceLoadingModalData: (state, action) => {
            state.loadingModalData = action.payload;
        },
        setSliceMobilePreviewData: (state, action) => {
            state.mobilePreviewData = action.payload;
        },
        setGlobalLoadingDisplay: (state, action) => {
            state.globalLoadingDisplay = action.payload;
        },
        setMobileFooterModalData: (state, action) => {
            state.mobileFooterModalData = action.payload;
        },
        setSliceUpgradeTipsModalData: (state, action) => {
            state.upgradeTipsModalData = action.payload;
        },
        setMobileSimplePreviewData: (state, action) => {
            state.mobileSimplePreviewData = action.payload;
        },
        setSliceIsShowRecordDisplay: (state, action) => {
            state.isShowRecordDisplay = action.payload;
        },
        setMediaLibraryInfo: (state, action) => {
            state.addMediaLibraryInfo = action.payload;
        },
        setAutoSelectionNoticeDisplay: (state, action) => {
            state.autoSelectionNoticeDisplay = action.payload;
        },
        setVideoTrimModelData: (state, action) => {
            state.videoTrimModelData = action.payload;
        },
        setServerBusyModalData: (state, action) => {
            state.serverBusyModalData = action.payload;
        },
        setAnimateImageModalDisplay: (state, action) => {
            state.animateImageModalDisplay = action.payload;
        },
        setTimeDiscountPanelData: (state, action) => {
            state.timeDiscountPanelData = action.payload;
        },
        setTimeDiscountSelectedIndex: (state, action) => {
            state.timeDiscountSelectedIndex = action.payload;
        },
        setMediaPreviewData: (state, action) => {
            state.mediaPreviewData = action.payload;
        },
        setSliceDoNotShowAgainData: (state, action) => {
            state.doNotShowAgainData = action.payload;
        },
        setCloudTranscodingModalData: (state, action) => {
            state.cloudTranscodingModalData = action.payload;
        },
    },
});

export const {
    setProgressAction,
    setSliceWarningModalData,
    setSlicePreviewModalData,
    setSliceImagePreviewModalData,
    setSliceImageCropModalData,
    setSliceUpgradeModalData,
    setSliceUploadImageAsPromptModalData,
    setSliceAddAsEditPageModalBtuStatus,
    setSliceLoadingModalData,
    setSliceMobilePreviewData,
    setGlobalLoadingDisplay,
    setMobileFooterModalData,
    setSliceUpgradeTipsModalData,
    setMobileSimplePreviewData,
    setSliceIsShowRecordDisplay,
    setMediaLibraryInfo,
    setAutoSelectionNoticeDisplay,
    setVideoTrimModelData,
    setServerBusyModalData,
    setAnimateImageModalDisplay,
    setTimeDiscountPanelData,
    setTimeDiscountSelectedIndex,
    setProgressModalData,
    setMediaPreviewData,
    setSliceDoNotShowAgainData,
    setCloudTranscodingModalData,
    setSliceDetailsPreviewModalData,
    setSliceReportModalData,
} = FJSliceModals.actions;

export default FJSliceModals.reducer;
